import { render, staticRenderFns } from "./LabTask.vue?vue&type=template&id=6859e5f0&scoped=true&"
import script from "./LabTask.vue?vue&type=script&lang=js&"
export * from "./LabTask.vue?vue&type=script&lang=js&"
import style0 from "./LabTask.vue?vue&type=style&index=0&id=6859e5f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6859e5f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
